import React, { useState, useEffect, useCallback } from "react";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Grid,
  Box,
  FormGroup,
  Divider,
  Chip,
  Autocomplete,
  CircularProgress,
  ListItem,
  ListItemIcon,
  List,
  Tooltip,
  Paper,
  Avatar,
} from "@mui/material";
import {
  Folder,
  InsertDriveFile,
  ConfirmationNumber,
  Event,
  ArrowBack,
  ArrowForward,
  Link,
  Delete,
  Add,
  Person,
  CheckCircle,
  Cancel,
  Schedule,
  Label,
  Assignment,
  Create,
  Update,
  Done,
  CloudUpload,
} from "@mui/icons-material";
import ConfirmationNumberIcon from "@mui/icons-material/ConfirmationNumber";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactSelect from "react-select";
import "./Crm.css";
import { ListItemService } from "../../../service/manage/crm/crm_list_item.service";
import DropdownCust from "./Components/DropdownCust";
import TextFieldCust from "./Components/TextfieldCust";
import { FieldListService } from "../../../service/manage/crm/crm_field_list.service";
import { debounce } from "lodash";
import { sweetStatusAlert } from "../../../components/common/SweetAlert";
import { CrmMainService } from "../../../service/manage/crm/crm_main.service";
import SimpleReactValidator from "simple-react-validator";
import AddLinkIcon from "@mui/icons-material/AddLink";
import BookmarkButton from "./Components/BookmarkButton";
import BlockLinkModal from "./Components/BlockLinkModal";
import Checkbox from "@mui/material/Checkbox";

export default function AnchorTemporaryDrawer({
  open,
  onClose,
  state,
  prevTicket,
  nextTicket,
  handleSearchFilter,
  selectedSearchFilter,
  fetchAllReminders,
}) {
  const [trialTitle, setTrialTitle] = useState("");
  const [blockGroupName, setBlockGroupName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [shortText, setShortText] = useState("");
  const [longText, setLongText] = useState("");
  const [reminders, setReminders] = useState([]);
  const [eta, setEta] = useState(null);
  const [searchTags, setSearchTags] = useState("");
  const [blockOwners, setBlockOwners] = useState([]);
  const [mappingLinks, setMappingLinks] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [selectedOption, setSelectedOption] = useState(17);
  const [taskStatusArr, setTaskStatusArr] = useState([]);
  const [blockStatusArr, setBlockStatusArr] = useState([]);
  const [selectedTaskStatus, setSelectedTaskStatus] = useState("");
  const [selectedBlockStatus, setSelectedBlockStatus] = useState("");
  const [statusesLoading, setStatusesLoading] = useState(false);
  const [isUserLoading, setisUserLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [sortColumn, setSortColumn] = useState("user_code");
  const [sortDirection, setSortDirection] = useState("desc");
  const [nextBlockTitle, setNextBlockTitle] = useState("");
  const [parentBlockTitle, setParentBlockTitle] = useState("");
  const [blockTitle, setBlockTitle] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [, forceUpdate] = useState({});

  const resetState = () => {
    setBlockGroupName("");
    setBlockName("");
    setShortText("");
    setLongText("");
    setReminders([]);
    setEta(null);
    setSearchTags("");
    setBlockOwners([]);
    setMappingLinks("");
    setAttachments([]);
    setSelectedOption(17);
    setTaskStatusArr([]);
    setBlockStatusArr([]);
    setSelectedTaskStatus("");
    setSelectedBlockStatus("");
    setStatusesLoading(false);
    setisUserLoading(false);
    setUsers([]);
    setUserSearchTerm("");
    setSortColumn("user_code");
    setSortDirection("desc");
    setNextBlockTitle("");
    setParentBlockTitle("");
    setSaveLoading(false);
    validator.hideMessages();
    validator.messagesShown = false;
    forceUpdate({});
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [linkedBlocks, setLinkedBlocks] = useState([]);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const [validator] = useState(() => {
    const validator = new SimpleReactValidator({
      className: "text-danger",
    });
    return validator;
  });

  useEffect(() => {
    if (open) {
      resetState();
      fetchAllUsers();
      fetchDropdownOptions();
    }
  }, [open]);

  useEffect(() => {
    if (prevTicket) {
      setParentBlockTitle(prevTicket.f16);
      setTrialTitle(prevTicket.f12 || "");
    }
    if (nextTicket) {
      setNextBlockTitle(nextTicket.f16);
      setTrialTitle(nextTicket.f12 || "");
    }
  }, [prevTicket, nextTicket]);

  const fetchDropdownOptions = async () => {
    try {
      setStatusesLoading(true);

      const [taskStatusResponse, blockStatusResponse] = await Promise.all([
        ListItemService.getListItemById(25),
        ListItemService.getListItemById(29),
      ]);

      setTaskStatusArr(taskStatusResponse.data);
      setBlockStatusArr(blockStatusResponse.data);

      setStatusesLoading(false);
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
      setStatusesLoading(false);
    }
  };

  const fetchAllUsers = async () => {
    setisUserLoading(true);

    try {
      const response = await FieldListService.getAllCrmUsers(
        state?.mid,
        state?.form_list_id,
        state?.lg_user_id,
        state?.lg_user_table_id,
        5000,
        0,
        sortColumn,
        sortDirection,
        userSearchTerm
      );
      setUsers(response?.data?.users || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setisUserLoading(false);
    }
  };

  const formatRemindersForSubmission = (reminders) => {
    return reminders.map((reminder) => {
      if (!reminder.date) {
        return `|${reminder.displayOrder}|${reminder.type}`;
      }

      const date = new Date(reminder.date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      const formattedDate = `${year}${month}${day}${hours}${minutes}`;
      return `${formattedDate}|${reminder.displayOrder}|${reminder.type}`;
    });
  };

  const formatDateToYYYYMMDDHHmm = (date) => {
    if (!date) {
      return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}${month}${day}${hours}${minutes}`;
  };

  const handleBlockOwnersSelect = (event, selectedOptions) => {
    const selectedUsers = selectedOptions.map(
      (option) => `${option.user_id}|${option.user_table_id}`
    );
    setBlockOwners(selectedUsers);
  };

  const handleTaskStatusChange = (event) => {
    setSelectedTaskStatus(event.target.value);
  };

  const handleBlockStatusChange = (event) => {
    setSelectedBlockStatus(event.target.value);
    validator.showMessageFor("selectedBlockStatus");
  };

  const addReminder = () => {
    if (reminders.length === 0 || reminders[reminders.length - 1] !== null) {
      setReminders([
        ...reminders,
        { date: null, displayOrder: reminders.length + 1, type: "" },
      ]);
    }
  };

  const handleReminderChange = (date, index) => {
    const updatedReminders = [...reminders];
    updatedReminders[index].date = date;
    setReminders(updatedReminders);
  };

  const handleTypeChange = (event, index) => {
    const updatedReminders = [...reminders];
    updatedReminders[index].type = event.target.value;
    setReminders(updatedReminders);
  };

  const removeReminder = (index) => {
    const updatedReminders = reminders.filter((_, i) => i !== index);
    setReminders(updatedReminders);
  };

  const handleRadioChange = (event) => {
    setSelectedOption(Number(event.target.value));
  };

  const getTitle = () => {
    switch (selectedOption) {
      case 17:
        return blockGroupName;
      case 18:
        return blockName;
      case 19:
        return shortText;
      default:
        return "";
    }
  };

  const handleSave = async () => {
    if (!validator.allValid()) {
      validator.showMessages();
      forceUpdate({});
      return;
    }
    try {
      setSaveLoading(true);

      const formattedReminders = formatRemindersForSubmission(reminders);
      const formattedEta = formatDateToYYYYMMDDHHmm(eta);

      const fomattedBlockLinks = formatBlockLinkForSubmission(linkedBlocks);

      const ticket = prevTicket || nextTicket || {};

      // Main payload for creating the new block
      const newTicketPayload = {
        node_id: state?.mid,
        user_id: state?.lg_user_id,
        user_table_id: state?.lg_user_table_id,
        create_user_id: state?.lg_user_id,
        trail_id: ticket?.f11,
        trail_title: ticket?.f12,
        create_user_table_id: state?.lg_user_table_id,
        block_title: blockTitle,
        block_title_id: selectedOption,
        block_group_name: blockGroupName,
        block_name: blockName,
        short_text: shortText,
        long_text: longText,
        reminders: formattedReminders,
        eta: formattedEta,
        search_tags: searchTags,
        block_owners: blockOwners,
        task_status: parseInt(selectedTaskStatus),
        block_status: parseInt(selectedBlockStatus),
        block_creator: [`${state?.lg_user_id}|${state?.lg_user_table_id}`],
        mappings: fomattedBlockLinks,
      };

      // Step 1: Create the new block
      const createResponse = await CrmMainService.crm_update_block(
        newTicketPayload
      );

      if (!createResponse.data || createResponse.data.length === 0) {
        setSaveLoading(false);
        sweetStatusAlert(
          "Failed!",
          "Failed to create block. No data returned.",
          "error"
        );
        return;
      }

      // Get the block_id from the createResponse
      const blockID = createResponse?.data[0]?.f14;

      // Step 2: Determine the position and update adjacent blocks
      const isAddingAtStart = !prevTicket && nextTicket;
      const isAddingAtEnd = prevTicket && !nextTicket;
      const isAddingInBetween = prevTicket && nextTicket;

      if (isAddingAtStart) {
        const updateNextTicketPayload = {
          block_id: nextTicket.f14,
          parent_block_id: blockID,
        };
        await CrmMainService.crm_update_block_order(updateNextTicketPayload);

        const updateNewTicketPayload = {
          block_id: blockID,
          next_block_id: nextTicket.f14,
          parent_block_id: null,
        };
        await CrmMainService.crm_update_block_order(updateNewTicketPayload);
      } else if (isAddingAtEnd) {
        const updatePrevTicketPayload = {
          block_id: prevTicket.f14,
          next_block_id: blockID,
        };
        await CrmMainService.crm_update_block_order(updatePrevTicketPayload);

        const updateNewTicketPayload = {
          block_id: blockID,
          parent_block_id: prevTicket.f14,
          next_block_id: null,
        };
        await CrmMainService.crm_update_block_order(updateNewTicketPayload);
      } else if (isAddingInBetween) {
        const updatePrevTicketPayload = {
          block_id: prevTicket.f14,
          next_block_id: blockID,
        };
        await CrmMainService.crm_update_block_order(updatePrevTicketPayload);

        const updateNextTicketPayload = {
          block_id: nextTicket.f14,
          parent_block_id: blockID,
        };
        await CrmMainService.crm_update_block_order(updateNextTicketPayload);

        const updateNewTicketPayload = {
          block_id: blockID,
          parent_block_id: prevTicket.f14,
          next_block_id: nextTicket.f14,
        };
        await CrmMainService.crm_update_block_order(updateNewTicketPayload);
      }

      setSaveLoading(false);
      sweetStatusAlert(
        "Success!",
        "Block created and updated successfully!",
        "success"
      );

      handleCloseModal();
      await fetchAllReminders();
      await handleSearchFilter();
    } catch (error) {
      console.error("Error:", error);
      setSaveLoading(false);
      sweetStatusAlert("Failed!", "Failed to create or update Block", "error");
    }
  };

  const handleCloseModal = () => {
    validator.hideMessages();
    forceUpdate({});

    onClose();
  };

  const formatBlockLinkForSubmission = (linkedBlocks) => {
    return linkedBlocks.map((block, index) => {
      return `${block.block_id}|${block.displayOrder}|${block.comment}`;
    });
  };

  const handleAddLink = (comment, targetBlock) => {
    setLinkedBlocks((prevLinkedBlocks) => {
      const maxDisplayOrder = prevLinkedBlocks.reduce(
        (max, linkedBlock) => Math.max(max, linkedBlock.displayOrder),
        0
      );
      return [
        ...prevLinkedBlocks,
        {
          block_id: targetBlock.f14,
          displayOrder: maxDisplayOrder + 1,
          comment: comment,
        },
      ];
    });
  };

  const handleRemoveLink = (block) => {
    setLinkedBlocks((prevLinkedBlocks) => {
      const updatedLinkedBlocks = prevLinkedBlocks
        .filter((linkedBlock) => linkedBlock.block_id !== block.block_id)
        .map((linkedBlock, index) => ({
          ...linkedBlock,
          displayOrder: index + 1,
        }));
      return updatedLinkedBlocks;
    });
  };

  const list = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card
        style={{
          width: "600px",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <CardContent>
          {/* Header */}
          <div>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              marginBottom="8px"
            >
              <Typography
                variant="h6"
                style={{
                  fontWeight: "bold",
                  color: "#172B4D",
                  borderRadius: "4px",
                  padding: "4px",
                }}
              >
                {getTitle() || "N/A"}
              </Typography>
            </Box>
          </div>
          {/* <BookmarkButton selectedSearchFilter={selectedSearchFilter} /> */}

          <Divider style={{ margin: "8px 0" }} />

          {/* Editable Fields */}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextFieldCust
                fullWidth
                label="Trial Title"
                value={trialTitle}
                disabled={!!trialTitle}
                onChange={(e) => setTrialTitle(e.target.value)}
                margin="normal"
                variant="outlined"
                error={validator.message("trialTitle", trialTitle, "required")}
                helperText={validator.message(
                  "trialTitle",
                  trialTitle,
                  "required"
                )}
              />
            </Grid>
            {/* <Grid item xs={12}>
              <TextField
                fullWidth
                label="Block Title"
                value={blockTitle}
                margin="normal"
                onChange={(e) => setBlockTitle(e.target.value)}
                variant="outlined"
                error={validator.message("blockTitle", blockTitle, "required")}
                helperText={validator.message(
                  "blockTitle",
                  blockTitle,
                  "required"
                )}
              />
            </Grid> */}
          </Grid>

          <FormControl component="fieldset" fullWidth>
            <FormGroup>
              <Box display="flex" alignItems="center" mb={1}>
                <RadioGroup value={selectedOption} onChange={handleRadioChange}>
                  <FormControlLabel
                    value={17}
                    control={<Radio />}
                    label="Block Group Name"
                  />
                </RadioGroup>
                <TextFieldCust
                  fullWidth
                  value={blockGroupName}
                  onChange={(e) => setBlockGroupName(e.target.value)}
                  margin="normal"
                  label="Block Group Name"
                  variant="outlined"
                  error={validator.message(
                    "blockGroupName",
                    blockGroupName,
                    "required"
                  )}
                  helperText={validator.message(
                    "blockGroupName",
                    blockGroupName,
                    "required"
                  )}
                />
              </Box>

              <Box display="flex" alignItems="center" mb={1}>
                <RadioGroup value={selectedOption} onChange={handleRadioChange}>
                  <FormControlLabel
                    value={18}
                    control={<Radio />}
                    label="Block Name"
                  />
                </RadioGroup>
                <TextFieldCust
                  fullWidth
                  value={blockName}
                  onChange={(e) => setBlockName(e.target.value)}
                  margin="normal"
                  label="Block Name"
                  variant="outlined"
                  error={validator.message("blockName", blockName, "required")}
                  helperText={validator.message(
                    "blockName",
                    blockName,
                    "required"
                  )}
                />
              </Box>

              <Box display="flex" alignItems="center" mb={1}>
                <RadioGroup value={selectedOption} onChange={handleRadioChange}>
                  <FormControlLabel
                    value={19}
                    control={<Radio />}
                    label="Short Text"
                  />
                </RadioGroup>
                <TextFieldCust
                  fullWidth
                  value={shortText}
                  onChange={(e) => setShortText(e.target.value)}
                  margin="normal"
                  label="Short Text"
                  variant="outlined"
                  error={validator.message("shortText", shortText, "required")}
                  helperText={validator.message(
                    "shortText",
                    shortText,
                    "required"
                  )}
                />
              </Box>
            </FormGroup>
          </FormControl>

          <TextFieldCust
            fullWidth
            label="Long Text"
            value={longText}
            onChange={(e) => setLongText(e.target.value)}
            margin="normal"
            multiline
            rows={4}
            variant="outlined"
          />

          <Box display="flex" alignItems="center">
            <Schedule color="primary" /> &nbsp;
            <p className="DateNTime">Date & Time – Reminder(s)</p>
          </Box>

          {reminders.map((reminder, index) => (
            <Grid
              container
              key={index}
              spacing={2}
              alignItems="center"
              style={{
                marginBottom: 10,
                padding: 10,
                border: "1px solid #ddd",
                borderRadius: 8,
              }}
            >
              <Grid item xs={6}>
                <DatePicker
                  selected={reminder.date}
                  onChange={(date) => handleReminderChange(date, index)}
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  timeCaption="Time"
                  dateFormat="MMMM d, yyyy h:mm aa"
                  calendarClassName="custom-calendar"
                  popperClassName="custom-popper"
                  placeholderText="Select date and time"
                  minDate={new Date()}
                  // style={{ width: "100%" }}
                  className="date-picker-custom"
                  autoComplete="off"
                  onChangeRaw={(e) => e.preventDefault()} // Prevents manual typing
                  onFocus={(e) => e.target.blur()} // Prevents cursor appearance
                  popperPlacement="bottom-start" // Controls calendar popup position
                />
              </Grid>
              <Grid item xs={4}>
                <TextFieldCust
                  value={reminder.type}
                  onChange={(event) => handleTypeChange(event, index)}
                  placeholder="Type your reminder here"
                  variant="outlined"
                  fullWidth
                />
              </Grid>
              <Grid item xs={2}>
                <IconButton onClick={() => removeReminder(index)} color="error">
                  <Delete />
                </IconButton>
                {index === reminders.length - 1 && reminder.date !== null && (
                  <IconButton
                    onClick={addReminder}
                    color="primary"
                    style={{ marginLeft: "10px" }}
                  >
                    <Add />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          ))}

          {reminders.length === 0 && (
            <Button
              onClick={addReminder}
              variant="outlined"
              startIcon={<Add />}
              style={{ marginTop: "10px" }}
            >
              Add Reminder
            </Button>
          )}

          <Box display="flex" alignItems="center" mt={1} mb={1}>
            <Schedule color="primary" />
            <p className="DateNTime">Date & Time – ETA</p>
          </Box>
          <div style={{ gap: "8px", display: "flex", flexDirection: "column" }}>
            <DatePicker
              className="date-picker-custom"
              selected={eta}
              onChange={(date) => setEta(date)}
              minDate={new Date()}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="MMMM d, yyyy h:mm aa"
              calendarClassName="custom-calendar"
              popperClassName="custom-popper"
              margin="normal"
              autoComplete="off"
              onChangeRaw={(e) => e.preventDefault()} // Prevents manual typing
              onFocus={(e) => e.target.blur()} // Prevents cursor appearance
              popperPlacement="bottom-start" // Controls calendar popup position
            />
            <p className="DateNTime">Search Tag(s)</p>
            <TextFieldCust
              fullWidth
              label="Search Tag(s)"
              value={searchTags}
              onChange={(e) => setSearchTags(e.target.value)}
              margin="normal"
              variant="outlined"
            />
          </div>
          <Box mt={1} mb={1}>
            <Typography variant="body2">
              <Person color="primary" style={{ marginRight: "10px" }} />
              Block Owner(s)
            </Typography>
            <Autocomplete
              multiple
              freeSolo
              options={users}
              getOptionLabel={(option) => option.data_concat}
              value={users.filter((user) =>
                blockOwners.includes(`${user.user_id}|${user.user_table_id}`)
              )}
              onChange={handleBlockOwnersSelect}
              onInputChange={(event, newInputValue) =>
                setUserSearchTerm(newInputValue)
              }
              loading={isUserLoading}
              renderInput={(params) => (
                <TextField {...params} placeholder="Select block owners..." />
              )}
            />
          </Box>

          <Box mt={1} mb={1}>
            <Typography variant="body2">
              <Assignment color="primary" style={{ marginRight: "10px" }} />
              Task Status
            </Typography>
            <DropdownCust
              value={selectedTaskStatus}
              onChange={handleTaskStatusChange}
              disabled={statusesLoading}
              placeholder="Select.."
            >
              {statusesLoading ? (
                <option>Loading...</option>
              ) : (
                taskStatusArr.map((option) => (
                  <option
                    key={option.display_order}
                    value={option.display_order}
                  >
                    {option.list_item}
                  </option>
                ))
              )}
            </DropdownCust>
          </Box>
          <Box mt={1} mb={1}>
            <Typography variant="body2">
              <Assignment color="primary" style={{ marginRight: "10px" }} />
              Block Status
            </Typography>
            <DropdownCust
              value={selectedBlockStatus}
              onChange={handleBlockStatusChange}
              disabled={statusesLoading}
              placeholder="Select.."
            >
              {statusesLoading ? (
                <option>Loading...</option>
              ) : (
                blockStatusArr.map((option) => (
                  <option
                    key={option.display_order}
                    value={option.display_order}
                  >
                    {option.list_item}
                  </option>
                ))
              )}
            </DropdownCust>

            {validator.message(
              "selectedBlockStatus",
              selectedBlockStatus,
              "required"
            )}
          </Box>

          <div className="d-flex align-items-center mb-2">
            <Typography variant="subtitle2">
              <p>Linked Tickets</p>
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              <Tooltip title="Mapping (links)">
                <IconButton onClick={handleOpen}>
                  <AddLinkIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div
              style={{ display: "flex" }}
              sx={{
                flexDirection: "row",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {linkedBlocks?.map((block, index) => {
                return (
                  <ListItem
                    key={index}
                    sx={{ width: "auto", padding: "4px", minHeight: "8px" }}
                  >
                    <Chip
                      label={`[${block.block_id}] ${
                        block.comment.length > 7
                          ? `${block.comment.slice(0, 7)}...`
                          : block.comment
                      }`}
                      avatar={
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Checkbox
                            size="small"
                            sx={{
                              padding: "0 8px",
                              "&.Mui-checked": {
                                color: "#773e87",
                              },
                            }}
                          />
                          <Avatar sx={{ marginLeft: "2px" }}>
                            {block.displayOrder}
                          </Avatar>
                        </Box>
                      }
                      onDelete={() => handleRemoveLink(block)}
                      sx={{
                        "& .MuiChip-avatar": {
                          width: "auto",
                          marginLeft: "0",
                        },
                        backgroundColor: "#f9ebfc",
                        "&:hover": {
                          backgroundColor: "#f0d9f5",
                        },
                      }}
                    />
                  </ListItem>
                );
              })}
            </div>
          </div>
          <div mt={1} mb={1}>
            <Typography variant="body2">
              <Folder color="primary" style={{ marginRight: "10px" }} />
              Attachments
            </Typography>
            <Button
              variant="outlined"
              startIcon={<CloudUpload />}
              style={{ marginTop: "10px" }}
            >
              Upload Attachment
            </Button>
          </div>

          <Grid container spacing={3} mt={3}>
            <List
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mt: 2,
                width: "96%",
              }}
            >
              <div>
                {prevTicket && (
                  <Box>
                    <Typography variant="body2">
                      <ConfirmationNumberIcon
                        color="primary"
                        style={{ marginRight: "10px" }}
                      />
                      Previous Ticket
                    </Typography>
                    <Chip
                      label={parentBlockTitle}
                      variant="outlined"
                      icon={<ArrowBack color="primary" />}
                      sx={{
                        backgroundColor: "#e3f2fd",
                        borderRadius: "8px",
                        px: 2,
                        "&:hover": { backgroundColor: "#bbdefb" },
                      }}
                    />
                  </Box>
                )}
              </div>
              <div>
                {nextTicket && (
                  <Box>
                    <Typography variant="body2">
                      <ConfirmationNumberIcon
                        color="primary"
                        style={{ marginRight: "10px" }}
                      />
                      Next Ticket
                    </Typography>
                    <Chip
                      label={nextBlockTitle}
                      variant="outlined"
                      icon={<ArrowForward color="primary" />}
                      sx={{
                        backgroundColor: "#e3f2fd",
                        borderRadius: "8px",
                        px: 2,
                        "&:hover": { backgroundColor: "#bbdefb" },
                      }}
                    />
                  </Box>
                )}
              </div>
            </List>
          </Grid>

          {/* Save Button */}
          <Button
            onClick={handleSave}
            variant="contained"
            fullWidth
            sx={{
              backgroundColor: "#1ea5d0",
              color: "white",
              marginTop: "16px",
            }}
            disabled={saveLoading}
          >
            {saveLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Create"
            )}
          </Button>

          {/* Footer Navigation */}
        </CardContent>
      </Card>
    </div>
  );

  const isMobile = useMediaQuery("(max-width:600px)");
  const drawerWidth = isMobile ? 300 : 600;

  return (
    <Drawer anchor="right" open={open} onClose={handleCloseModal}>
      <div style={{ width: drawerWidth, padding: 20 }}>
        {list()}
        {modalOpen && (
          <BlockLinkModal
            selectedBlock={selectedSearchFilter}
            handleClose={handleClose}
            modalOpen={modalOpen}
            handleAddLink={handleAddLink}
            linkedBlocks={linkedBlocks}
          />
        )}
      </div>
    </Drawer>
  );
}
